import {IS_SHOW_LOADING} from './types';

export default {
    IS_SHOW_LOADING(state, show){
        state.showLoading = show;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js